// SPDX-License-Identifier: AGPL-3.0-or-later

import * as AccessibilityCommands from '@app/features/accessibility/commands/AccessibilityCommands';
import Accessibility from '@app/features/accessibility/state/Accessibility';
import {Switch} from '@app/features/ui/components/form/Switch';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';
export const MotionTabContent: React.FC = observer(() => {
	const {t} = useLingui();
	const syncReducedMotionWithSystem = Accessibility.syncReducedMotionWithSystem;
	const reducedMotionOverride = Accessibility.reducedMotionOverride;
	return (
		<>
			<Switch
				label={t`Sync reduced motion setting with system`}
				description={t`Automatically use your system's reduced motion preference, or customize it below.`}
				value={syncReducedMotionWithSystem}
				onChange={(value) => AccessibilityCommands.update({syncReducedMotionWithSystem: value})}
			/>
			<Switch
				label={t`Reduce Motion`}
				description={
					syncReducedMotionWithSystem
						? t`Disable animations and transitions. Currently controlled by your system setting.`
						: t`Disable animations and transitions throughout the app.`
				}
				value={syncReducedMotionWithSystem ? Accessibility.useReducedMotion : (reducedMotionOverride ?? false)}
				disabled={syncReducedMotionWithSystem}
				onChange={(value) => AccessibilityCommands.update({reducedMotionOverride: value})}
			/>
		</>
	);
});
